import { render, staticRenderFns } from "./AdminSaleReq.vue?vue&type=template&id=dd1ced1e&scoped=true&"
import script from "./AdminSaleReq.vue?vue&type=script&lang=js&"
export * from "./AdminSaleReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1ced1e",
  null
  
)

export default component.exports